import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { AnnouncementBanner } from '../Home/AnnouncementBanner';
interface LayoutProps {
  children: React.ReactNode;
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
  openPaymentForm?: () => void;
}
export const Layout = ({
  children,
  openRegistrationForm,
  openHostSalonForm,
  openPaymentForm
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen" data-id="element-823">
      <AnnouncementBanner data-id="element-824" />
      <div className="h-[32px]" data-id="element-825"></div>
      <Header openRegistrationForm={openRegistrationForm} openPaymentForm={openPaymentForm} data-id="element-826" />
      <main className="flex-grow pt-[76px]" data-id="element-827">{children}</main>
      <Footer openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} data-id="element-828" />
    </div>;
};